import React from 'react';

import { formatCurrency } from 'js/services/Format';

import Row from './Row';
import Label from './Label';
import Value from './Value';

export default ({ label, negative,  children }) => (
  <Row>
    <Label>{label}</Label>
    <Value>{negative?'-':''}{formatCurrency(children)}</Value>
  </Row>
);
